export default {
  title: '汇率设置',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '币种代码、名称',
    fromCurrency: '币种',
    fromCurrencyPlaceholder: '选择币种',
    toCurrency: '本位币',
    toCurrencyPlaceholder: '选择本位币',
    status: '状态',
    statusPlaceholder: '选择状态',
    all: '全部',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addExchangeRate: '新增汇率',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    edit: '编辑',
    view: '查看',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    fromCurrency: '币种',
    toCurrency: '本位币',
    exchangeRate: '汇率',
    effectiveDate: '有效期',
    to: '至',
    status: '状态',
    updateTime: '更新时间',
    operation: '操作'
  },

  // 表单
  form: {
    addTitle: '新增汇率设置',
    editTitle: '编辑汇率设置',
    fromCurrency: '币种',
    fromCurrencyPlaceholder: '请选择币种',
    toCurrency: '本位币',
    toCurrencyPlaceholder: '请选择本位币',
    exchangeRate: '汇率',
    exchangeRatePlaceholder: '请输入汇率',
    dateRange: '有效期',
    dateRangePlaceholder: '请选择有效期',
    startDatePlaceholder: '开始日期',
    endDatePlaceholder: '结束日期'
  },

  // 详情弹窗
  detail: {
    title: '汇率设置详情',
    fromCurrency: '币种：',
    toCurrency: '本位币：',
    exchangeRate: '汇率：',
    effectiveDate: '生效日期：',
    expiryDate: '失效日期：',
    status: '状态：',
    updateTime: '更新时间：',
    close: '关闭'
  },

  // 确认对话框
  confirm: {
    toggleStatus: '确认{action}',
    toggleStatusContent: '确定要将此汇率设置状态设为{action}吗？',
    batchEnable: '确认批量启用',
    batchEnableContent: '确定要将选中的 {count} 个汇率设置设为启用状态吗？',
    batchDisable: '确认批量禁用',
    batchDisableContent: '确定要将选中的 {count} 个汇率设置设为禁用状态吗？'
  },

  // 表单验证
  validation: {
    fromCurrencyRequired: '请选择币种',
    toCurrencyRequired: '请选择本位币',
    exchangeRateRequired: '请输入汇率',
    dateRangeRequired: '请选择有效期',
    exchangeRateFormat: '汇率必须为正数',
    currencyDifferent: '币种和本位币不能相同'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的汇率设置',
    selectToDisable: '请选择要禁用的汇率设置',
    loadError: '数据加载失败',
    currencyLoadError: '加载币种选项失败',
    saveSuccess: '汇率设置保存成功',
    saveError: '保存失败，请稍后重试',
    updateSuccess: '汇率设置更新成功',
    updateError: '更新失败，请稍后重试',
    statusToggleSuccess: '汇率设置状态已更新为{status}',
    statusToggleError: '状态切换失败',
    batchEnableSuccess: '汇率设置状态已批量更新为启用',
    batchEnableError: '批量启用失败',
    batchDisableSuccess: '汇率设置状态已批量更新为禁用',
    batchDisableError: '批量禁用失败',
    dateOverlapError: '该币种对本位币在此时间段内已存在汇率设置，有效期不能有交叉或重叠！'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 币种选项
  currencies: {
    CNY: 'CNY - 人民币',
    USD: 'USD - 美元',
    EUR: 'EUR - 欧元',
    JPY: 'JPY - 日元',
    GBP: 'GBP - 英镑',
    HKD: 'HKD - 港币',
    SGD: 'SGD - 新加坡元',
    AUD: 'AUD - 澳元',
    CAD: 'CAD - 加元'
  }
}